import { RootState } from 'store/store';

export const selectEmployeeCount = (state: RootState) => state.employee.count;
export const selectEmployees = (state: RootState) => state.employee.employees;
export const selectEmployeeData = (state: RootState) => state.employee.data;
export const selectEmployeeRequestStatus = (state: RootState) => state.employee.requestStatus;
export const selectEmployeesStatus = (state: RootState) => state.employee.employeesRequestStatus;
